import { getRegionFromCurrency } from './getRegionFromCurrency';
import { getRegionFromLocale } from './getRegionFromLocale';
export const getRegion = ({ paymentRequestId, currency, locale }) => {
    if (paymentRequestId) {
        const paymentRequestIdParts = paymentRequestId.split(':');
        if (paymentRequestIdParts.length >= 3) {
            const klarnaRegion = paymentRequestId.split(':')[2];
            return klarnaRegion.substring(0, 2);
        }
    }
    if (currency) {
        return getRegionFromCurrency(currency);
    }
    return getRegionFromLocale(locale);
};
